import React, { useState, useEffect } from 'react';

import './styles.css';

import classServices from '../../../../../services/academy/classServices';
import studentsServices from '../../../../../services/academy/studentsServices';

import compare from '../../../../../functions/compare';

import Popup from '../../../../../components/Popup';
import SelectGroup from '../../../../../components/SelectGroup';
import Notice from '../../../../../components/Notice';
import { FaUsers } from 'react-icons/fa';

function PopupClassChange(props) {
    const [studentClass, setStudentClass] = useState();
    const [selectList, setSelectList] = useState([]);
    const [hideList, setHideList] = useState([]);
    const [classes, setClasses] = useState([]);

    useEffect(() => {
        if (props.studentGender && props.studentAge != null)
            readClasses();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.studentGender, props.studentAge]);

    useEffect(() => {
        if (props.classId && props.visibility)
            // eslint-disable-next-line array-callback-return
            classes.filter((item, index) => {
                if (item.id === props.classId) {
                    setSelectList([index]);
                    setStudentClass(index);
                }
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.classId, props.visibility]);

    useEffect(() => {
        setHideList(classes.map((item, index) => item.numero_vagas - item.numero_alunos > 0 ? -1 : index).filter((item) => item !== -1));
    }, [classes]);

    async function readClasses() {
        const response = await classServices.getClasses();
        if (response.status === 200) {
            setClasses(response.data
                .filter((item) =>
                    (item.tipo === "Mista" || item.tipo[0] === props.studentGender[0])
                    && props.studentAge <= Number(item.faixa_etaria.substring(4))
                )
                .sort((a, b) => compare(a.nome, b.nome))
                .sort((a, b) => compare(a.numero_vagas - a.numero_alunos, b.numero_vagas - b.numero_alunos))
                .sort((a, b) => compare(Number(a.faixa_etaria.substring(4)), Number(b.faixa_etaria.substring(4))))
            );
        } else
            alert("Erro ao ler turmas, tente novamente!");
    };

    async function updateStudentClass() {
        if (selectList.length) {
            if (selectList[0] !== studentClass) {
                const response = await studentsServices.patchStudentClass(props.studentId, classes[selectList[0]].id);
                if (response.status === 200) {
                    readClasses();
                    props.setClassInfos(response.data.turma);
                    props.setVisibility(false);
                } else
                    alert("Erro ao atualizar turma do aluno, tente novamente!");
            } else
                alert("O aluno já está inscrito nessa turma.");
        } else
            alert("Escolha uma turma para inscrever o aluno.");
    };

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaUsers />}
            tittle='Turmas'
        >
            {
                classes.length ?
                    <>
                        <SelectGroup
                            single={true}

                            hides={hideList}
                            markeds={selectList}
                            setMarkeds={setSelectList}
                        >
                            {
                                classes.map((item, index) => {
                                    const vagas = item.numero_vagas - item.numero_alunos;
                                    return <div key={item.id} className='select-group-student-class-change'>
                                        <div className='select-group-student-class-change-tittle'>
                                            <p className='tittle'>{item.nome}</p>
                                            <span className='tag small dark-blue'>{vagas ? vagas + ' vagas' : "Não há vagas"}</span>
                                        </div>
                                        <p>{`${item.faixa_etaria} - ${item.tipo}`}</p>
                                    </div>
                                }
                                )
                            }
                        </SelectGroup>
                        <button type='button' onClick={updateStudentClass}>Inscrever aluno</button>
                    </>
                    : <Notice>Não há turmas disponíveis para inscrição</Notice>
            }
        </Popup>
    )
}

export default PopupClassChange;